import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 14,
    color: "green",
  },
  card: {
    [theme.breakpoints.up("xs")]: {
      width: "8em",
      height: "8em",
    },
    [theme.breakpoints.down("xs")]: {
      width: "5em",
      height: "5em",
    },
    boxShadow: "0px 4px 4px rgba(51, 51, 51, 0.04), 0px 4px 24px rgba(51, 51, 51, 0.24)",
  },
  action: {
    padding: 15,
    height: "100%",
  },
  icon: {
    height: "2em",
  },
  iconSm: {
    height: "1em",
  },
  selected: {
    border: "2px solid " + theme.palette.primary.main,
  },
  root: {
    root: {
      width: 500,
    },
  },
  noPadding: {
    padding: "5px",
    paddingBottom: "5px",
  },
}));
